import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-702657bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invest-detail-content" }
const _hoisted_2 = { class: "invest-detail-box" }
const _hoisted_3 = { class: "invest-detail-box-tp" }
const _hoisted_4 = { class: "invest-detail-box-title" }
const _hoisted_5 = {
  key: 0,
  class: "invest-detail-box-sub"
}
const _hoisted_6 = { class: "invest-detail-box-time" }
const _hoisted_7 = { class: "invest-detail-box-address" }
const _hoisted_8 = { class: "invest-detail-box-address" }
const _hoisted_9 = {
  key: 1,
  class: "invest-detail-box-status status3"
}
const _hoisted_10 = {
  key: 2,
  class: "invest-detail-box-status status4"
}
const _hoisted_11 = {
  key: 3,
  class: "invest-detail-box-status status5"
}
const _hoisted_12 = {
  key: 4,
  class: "invest-detail-box-status status6"
}
const _hoisted_13 = {
  key: 5,
  class: "invest-detail-box-number"
}
const _hoisted_14 = { class: "invest-detail-box-wz" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/_createTextVNode("会员报名")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("非会员报名")
const _hoisted_18 = { class: "invest-detail-rt" }
const _hoisted_19 = { class: "invest-detail-hd" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invest-detail-title" }, "最新培训", -1))
const _hoisted_21 = { class: "industry-detail-rt-box" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "industry-detail-rt-line-address" }
const _hoisted_24 = { class: "industry-detail-rt-line-nums" }
const _hoisted_25 = { class: "invest-detail-ad" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invest-detail-ad-bt" }, null, -1))
const _hoisted_28 = { class: "invest-detail-ad-label" }

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import { Plus, ZoomIn, Download, Delete } from '@element-plus/icons-vue';
import type { UploadFile } from 'element-plus/es/components/upload/src/upload.type';
import { useRouter } from 'vue-router'
import Bottom from '../components/bottom.vue'
import { OfficeBuilding, Clock, Location, Phone } from '@element-plus/icons-vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
var id = router.currentRoute.value.params.id;
const bindData = reactive({
  activity: {
    id: '',
    name: '',
    status: '',
    type: '',
    statusName: '',
    roomNumberName: '',
    deliveryDateString: '',
    decorateTypeName: '',
    thumbnailUrl: '',
    projectName: '',
    companyName: '',
    province: '',
    city: '',
    address: '',
    contact: '',
    mobile: '',
    lessonName: '',
    startTimeString: '',
    endTimeDateString: '',
    remainApplyNumber: 0,
    imageList: [],
    request: ''
  },
  activityList: [],
  newActivityList: [],
});
if (typeof id == "string") {
  store.dispatch("frontTrainingModule/getActivity", { id: id }).then(
    (data) => {
      //成功
      bindData.activity = data.result;
      loadData(data.result.companyCode, bindData.activity.type);
    },
    (error) => {
      console.log(error.msg);
    }
  );
}

const handleToDetail = (id: string) => {
  router.push('/frontDesk/trainingIndex/trainingDetail/' + id)
}

const handleToMemberTabel = () => {
  router.push('/frontDesk/trainingIndex/trainingMemberTabel/' + id)
}

const handleToTabel = () => {
  router.push('/frontDesk/trainingIndex/trainingTabel/' + id)
};

let root = ref(null);

const gotoBottom = () => {
  root.value.scrollTop = root.value.scrollHeight;
}

const loadData = (companyCode: string, activityType: any) => {
  store.dispatch("frontTrainingModule/listActivity", {
    //companyCode: companyCode,
    type: activityType,
    limit: 6,
  }
  )
    .then(
      (data) => {
        //成功
        bindData.activityList = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
  store.dispatch("frontTrainingModule/listActivity", {
    //companyCode: companyCode,
    type: activityType,
    status: 4,
    limit: 6,
  }
  )
    .then(
      (data) => {
        //成功
        bindData.newActivityList = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
}


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "invest-detail",
      ref_key: "root",
      ref: root
    }, [
      _createVNode(_component_el_container, { class: "invest-detail-main" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_carousel, { class: "invest-detail-carousel" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).activity.imageList, (image) => {
                    return (_openBlock(), _createBlock(_component_el_carousel_item, {
                      key: image.id,
                      style: {"display":"flex","justify-content":"center"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_image, {
                          class: "invest-detail-carousel-banner",
                          src: image.thumbnailUrl
                        }, null, 8, ["src"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(bindData).activity.name), 1),
                (_unref(bindData).activity.type == 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(OfficeBuilding))
                        ]),
                        _: 1
                      }),
                      _createTextVNode(_toDisplayString(_unref(bindData).activity.lessonName), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Clock))
                    ]),
                    _: 1
                  }),
                  _createTextVNode(_toDisplayString(_unref(bindData).activity.startTimeString) + " ~ " + _toDisplayString(_unref(bindData).activity.endTimeDateString), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Location))
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(bindData).activity.province) + "，" + _toDisplayString(_unref(bindData).activity.city) + "，" + _toDisplayString(_unref(bindData).activity.area) + "，" + _toDisplayString(_unref(bindData).activity.address), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Phone))
                    ]),
                    _: 1
                  }),
                  _createTextVNode(_toDisplayString(_unref(bindData).activity.contact) + _toDisplayString(_unref(bindData).activity.mobile), 1)
                ]),
                _createElementVNode("div", {
                  class: "invest-detail-box-status",
                  onClick: gotoBottom
                }, "报名"),
                (_unref(bindData).activity.status == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(bindData).activity.statusName), 1))
                  : (_unref(bindData).activity.status == 4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(bindData).activity.statusName), 1))
                    : (_unref(bindData).activity.status == 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(bindData).activity.statusName), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(bindData).activity.statusName), 1)),
                (_unref(bindData).activity.status == 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 剩余" + _toDisplayString(_unref(bindData).activity.remainApplyNumber) + "席", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", {
                  innerHTML: _unref(bindData).activity.request
                }, null, 8, _hoisted_15)
              ]),
              (_unref(bindData).activity.status == 4 && _unref(bindData).activity.remainApplyNumber > 0)
                ? (_openBlock(), _createBlock(_component_el_container, {
                    key: 0,
                    class: "invest-detail-box-btn"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElButton), {
                        type: "primary",
                        size: "large",
                        onClick: handleToMemberTabel
                      }, {
                        default: _withCtx(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(ElButton), {
                        type: "warning",
                        size: "large",
                        onClick: handleToTabel
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).newActivityList, (activity) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "industry-detail-rt-line",
                    key: activity.id
                  }, [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (handleToDetail(activity.id))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(activity.pushTimeString), 1),
                      _createElementVNode("span", _hoisted_23, _toDisplayString(activity.name) + " " + _toDisplayString(activity.province) + "." + _toDisplayString(activity.city), 1),
                      _createElementVNode("span", _hoisted_24, " 剩余" + _toDisplayString(activity.remainApplyNumber) + "席", 1)
                    ], 8, _hoisted_22)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).activityList, (activity) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "invest-detail-ad-box",
                  key: activity.id
                }, [
                  _createElementVNode("div", {
                    class: "invest-detail-ad-line",
                    onClick: ($event: any) => (handleToDetail(activity.id))
                  }, [
                    _createVNode(_component_el_carousel, {
                      class: "invest-detail-ad",
                      height: "200px"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.imageList, (image) => {
                          return (_openBlock(), _createBlock(_component_el_carousel_item, {
                            key: image.id,
                            style: {"display":"flex","justify-content":"center"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_image, {
                                class: "invest-detail-ad-banner",
                                mode: "widthfix",
                                src: image.thumbnailUrl
                              }, null, 8, ["src"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024),
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, _toDisplayString(activity.name) + " " + _toDisplayString(activity.lessonName) + " " + _toDisplayString(activity.pushTimeString), 1)
                  ], 8, _hoisted_26)
                ]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      })
    ], 512),
    _createVNode(Bottom)
  ]))
}
}

})